import Log from '@lib/Log'

export const logging = (message: string) => {
  Log.info(`logging('${message}')`)
}
